import React from 'react';
import { connect } from 'react-redux';
import AppBaseComponent from '../../components/AppBaseComponent';
import HttpAPICall from '../../services/HttpAPICall';
import { IAM_API_BASE_URL_2 } from '../../services/TapApiUrls';
import Ax from "../../components/hoc/Ax";
import Loader from "../../components/ui/Loader/Loader";
import { toast } from 'react-toastify';
import TapHelper from '../../services/TapHelper';
import DateService from '../../services/DateService';
import TapIcon from '../../services/TapIcon';
import { Link, withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import PaymentDetailModal from './PaymentDetailModal';

class ExpenseView extends AppBaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            expenseData: null,
            viewDataLoading: false,
            access_token: props.access_token,
            isLoaded: false
        };
        this.loadedExpenseId = null;
        this.paymentModalRef = React.createRef();

    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const expenseId = nextProps.expenseId || nextProps.expenseData?.detail?.transaction_id;
        if (expenseId && expenseId !== prevState.expenseData?.detail?.transaction_id) {
            return { expenseData: null, isLoaded: false };
        }
        return null;
    }

    componentDidMount() {
        this.initializeData(this.props);
    }

    componentDidUpdate(prevProps) {
        const expenseId = this.props.expenseId || this.props.expenseData?.detail?.transaction_id;
        const prevExpenseId = prevProps.expenseId || prevProps.expenseData?.detail?.transaction_id;

        if (expenseId && expenseId !== prevExpenseId && expenseId !== this.loadedExpenseId) {
            this.initializeData(this.props);
        }
    }

    initializeData = (props) => {
        const expenseId = props.expenseId || props.expenseData?.detail?.transaction_id;
        if (expenseId === this.loadedExpenseId && this.state.expenseData) {
            return;
        }

        if (props.expenseData) {
            this.setState({
                expenseData: props.expenseData,
                isLoaded: true,
                viewDataLoading: false
            });
            this.loadedExpenseId = props.expenseData.detail.transaction_id;
        } else if (props.expenseId) {
            this.getExpenseDetail(props.expenseId);
        }
    };

    getExpenseDetail = (id) => {
        if (id === this.loadedExpenseId && this.state.expenseData) {
            return;
        }

        this.setState({ viewDataLoading: true });
        HttpAPICall.withAthorization(
            'GET',
            IAM_API_BASE_URL_2 + '/expense/detail/' + id,
            this.state.access_token,
            {}, {},
            (response) => {
                this.setState({
                    expenseData: response.data,
                    viewDataLoading: false,
                    isLoaded: true
                });
                this.loadedExpenseId = id;
            },
            (error) => {
                toast.error(error?.msg || 'Error loading expense details', { position: toast.POSITION.TOP_RIGHT });
                this.setState({ viewDataLoading: false });
            }
        );
    };

    viewPaymentDetail = (id) => {
        this.paymentModalRef.current.paymentModalInit(id , this.state.expenseData?.detail)
    }

    paymentEditInit = (payment) => {
        this.props.props.history.push({
            pathname: `/payment_edit/${payment.transaction_id}`,
            state: {
                transaction_id: payment.transaction_id,
                isEdit: true
            }
        });
    };

    renderExpenseDetail = (expenseData) => {
        const expenseFor = expenseData?.detail?.expense_for;

        if (!expenseData) return null;

        return (
            <Ax>
                <div className="tab_content_wrapper my-2">
                    <span className="content_heading">Expense For </span>
                </div>
                <table className="table table-hover table-bordered">
                    <tbody>
                        <tr>
                            <td style={{ "width": "25%" }}>Expense For</td>
                            <th style={{ width: "65%" }} className="text-capitalize">
                                {expenseFor
                                    ? expenseFor
                                        .replace(/_/g, " ")
                                        .replace(/\b\w/g, (char) => char.toUpperCase())
                                    : "-"}
                            </th>
                        </tr>
                        {expenseFor === "employee" && expenseData?.detail?.employee && (
                            <> <tr>
                                <td style={{ "width": "25%" }}>Employee Name</td>
                                <th style={{ width: "65%" }}>{expenseData.detail.employee.name || expenseData.detail.employee.display_full_name || "-"}</th>
                            </tr>
                                <tr>
                                    <td style={{ "width": "25%" }}>Employee Code</td>
                                    <th style={{ width: "65%" }}>{expenseData.detail.employee.employee_code || "-"}</th>
                                </tr>
                            </>
                        )}
                        {expenseFor === "asset" && expenseData?.detail?.asset_profile && (
                            <>
                                <tr>
                                    <td style={{ "width": "25%" }}>Asset Name</td>
                                    <th style={{ width: "65%" }}>{expenseData.detail.asset_profile.name || "-"}</th>
                                </tr>
                                <tr>
                                    <td style={{ "width": "25%" }}>Asset Code</td>
                                    <th style={{ width: "65%" }}>{expenseData.detail.asset_profile.asset_code || "-"}</th>
                                </tr>
                                <tr>
                                    <td style={{ "width": "25%" }}>Asset Type</td>
                                    <th style={{ width: "65%" }}>{expenseData.detail.asset_profile.asset_type_name || "-"}</th>
                                </tr>
                                <tr>
                                    <td style={{ "width": "25%" }}>Counterlog</td>
                                    <th style={{ width: "65%" }}>{expenseData.detail?.counterlog_transaction_id || "-"}</th>
                                </tr>
                            </>
                        )}


                        {expenseFor === "customer" && expenseData?.detail?.customer && (
                            <>
                                <tr>
                                    <td style={{ "width": "25%" }}>Customer Name</td>
                                    <th style={{ width: "65%" }}>{expenseData.detail.customer.name || "-"}</th>
                                </tr>
                                <tr>
                                    <td style={{ "width": "25%" }}>Customer Code</td>
                                    <th style={{ width: "65%" }}>{expenseData.detail.customer.code || "-"}</th>
                                </tr>


                            </>
                        )}

                        {expenseFor === "workstation" && expenseData?.detail?.workstation && (
                            <>
                                <tr>
                                    <td style={{ "width": "25%" }}>Workstation Name</td>
                                    <th style={{ width: "65%" }}>{expenseData.detail.workstation.workstation_name || "-"}</th>
                                </tr>
                            </>
                        )}
                        {expenseFor === "sub_assembly" && expenseData?.detail?.sub_assembly && (
                            <>
                                <tr>
                                    <td style={{ "width": "25%" }}>Sub Assembly Name</td>
                                    <th style={{ width: "65%" }}>{expenseData.detail.sub_assembly.name || "-"}</th>
                                </tr>
                                <tr>
                                    <td style={{ "width": "25%" }}>Sub Assembly Code</td>
                                    <th style={{ width: "65%" }}>{expenseData.detail.sub_assembly.code || "-"}</th>
                                </tr>
                            </>

                        )}
                        {expenseFor === "site" && expenseData?.detail?.site && (
                            <>
                                <tr>
                                    <td style={{ "width": "25%" }}>Site Name</td>
                                    <th style={{ width: "65%" }}>{expenseData?.detail?.site?.site_name || "-"}</th>
                                </tr>
                                <tr>
                                    <td style={{ "width": "25%" }}>Site Code</td>
                                    <th style={{ width: "65%" }}>{expenseData?.detail?.site?.site_code || "-"}</th>
                                </tr>
                            </>

                        )}
                    </tbody>
                </table>

                <div className="tab_content_wrapper"> <span className="content_heading"> Expense Details</span></div>
                <table className="table my-2 table-hover table-bordered">
                    <tbody>
                        <tr>
                            <td style={{ "width": "25%" }}>Transaction ID</td>
                            <th style={{ "width": "65%" }}>{expenseData?.detail?.transaction_id ? expenseData?.detail.transaction_id : ''}   </th>
                        </tr>
                        <tr>
                            <td style={{ "width": "25%" }}>Date of Transaction</td>
                            <th style={{ "width": "65%" }}>  {expenseData?.detail?.expense_date ? DateService.dateFormat(expenseData?.detail?.expense_date) : "-"}</th>
                        </tr>
                        <tr>
                            <td style={{ "width": "25%" }}>Vendor</td>
                            <th style={{ "width": "65%" }} className="text-capitalize">{expenseData?.detail?.vendor ? expenseData?.detail?.vendor?.name : "-"}   </th>
                        </tr>
                        {expenseData?.detail?.ticket_id &&
                            <tr>
                                <td style={{ "width": "25%" }}>Ticket</td>
                                <th style={{ "width": "65%" }} className="text-capitalize">{expenseData?.detail?.ticket_id ? expenseData?.detail?.ticket_id : "-"}   </th>
                            </tr>}
                        <tr>
                            <td style={{ "width": "25%" }}>Reference Number</td>
                            <th style={{ "width": "65%" }} >{expenseData?.detail?.reference_number ? expenseData?.detail?.reference_number : ""}   </th>
                        </tr>
                        <tr>
                            <td style={{ "width": "25%" }}>Notes</td>
                            <th style={{ "width": "65%" }} >{expenseData?.detail?.details ? expenseData?.detail?.details : ""}   </th>
                        </tr>


                    </tbody>
                </table>
                {expenseData && expenseData.ticket && <Ax>
                    <div className="tab_content_wrapper mt-2">
                        <span className="content_heading">Ticket Details</span>
                    </div>
                    <table className="table table-hover table-bordered  table-responsive bg-white my-2 ">
                        <tbody>
                            <tr>
                                <td style={{ width: "25%" }}>Ticket ID</td>
                                <th style={{ width: "65%" }}>{expenseData?.ticket?.activity_id}</th>
                            </tr>
                            <tr>
                                <td style={{ width: "25%" }}>Ticket Type</td>
                                <th style={{ width: "65%" }}>{expenseData?.ticket?.ticket_type}</th>
                            </tr>
                            <tr>
                                <td style={{ width: "25%" }}>Ticket Header</td>
                                <th style={{ width: "65%" }}>{expenseData?.ticket?.header}</th>
                            </tr>
                        </tbody>
                    </table>
                </Ax>}

                <div className="tab_content_wrapper mt-3">
                    <span className="content_heading">Expense Head BreakUp</span>
                </div>
                <table className="table table-hover table-bordered  table-responsive bg-white my-2 ">
                    <thead className="table-secondary">
                        <tr>
                            <th scope="col" style={{ width: "5%" }}>S.No.</th>
                            <th scope="col" style={{ width: "30%" }}>Expense Head BreakUp</th>
                            <th scope="col" className="text-end" style={{ width: "35%" }}>Expense Head Amount</th>
                            <th scope="col" className="text-center" style={{ width: "30%" }}>Amount</th>

                        </tr>
                    </thead>
                    <tbody>
                        {expenseData?.detail?.expense_detail?.map((item, i) => {
                            const headData = expenseData?.expense_heads?.find(
                                head => head.id === item.head
                            );

                            return (<>
                                <tr key={i}>
                                    <td>{i + 1}</td>
                                    <td>{headData?.expense_head || "-"}</td>
                                    <td className="text-end">
                                        {TapHelper.dispayAsAmount(item.amount)}
                                    </td>
                                    {i === 0 && (
                                        <td
                                            rowSpan={expenseData.detail.expense_detail.length}
                                            className="text-center align-middle" >
                                            -
                                        </td>
                                    )}
                                </tr>

                            </>
                            );
                        })}
                        {expenseData?.detail?.expense_detail?.length > 0 && (
                            <tr>
                                <th colSpan={3} className="text-end ">
                                    Total Amount
                                </th>
                                <td className="text-center">{TapHelper.dispayAsAmount(
                                    expenseData.detail.expense_detail.reduce(
                                        (sum, item) => sum + Number(item.amount || 0),
                                        0
                                    )
                                )}</td>
                            </tr>
                        )}
                        {expenseData?.detail?.payment?.length > 0 && (
                            <tr>
                                <th colSpan={3} className="text-end ">
                                    Payment Amount
                                </th>
                                <td className="text-center">{TapHelper.dispayAsAmount(
                                    expenseData.detail.payment.reduce(
                                        (sum, item) => sum + Number(item?.payment_link?.payment_amount || 0),
                                        0
                                    )
                                )}</td>
                            </tr>
                        )}
                        {expenseData?.detail?.payment?.length > 0 && (
                            <tr>
                                <th colSpan={3} className="text-end">
                                    Balance Amount
                                </th>
                                <td className="text-center">
                                    {TapHelper.dispayAsAmount(
                                        expenseData.detail.expense_detail?.reduce(
                                            (sum, item) => sum + Number(item?.amount || 0),
                                            0
                                        ) -
                                        (expenseData.detail.payment?.reduce(
                                            (sum, item) => sum + Number(item?.payment_link?.payment_amount || 0),
                                            0
                                        ) || 0)
                                    )}
                                </td>
                            </tr>)}
                    </tbody>
                </table>
                <div className="tab_content_wrapper mt-3">
                    <span className="content_heading">Other Details</span>
                </div>
                <table className="table my-2 table-hover table-bordered">
                    <tbody>
                        <tr>
                            <td style={{ "width": "25%" }}>Document</td>
                            <th style={{ "width": "65%" }} >{expenseData?.detail?.invoice_url ? <a target="_blank" href={expenseData?.detail?.invoice_url}>View Document</a> : ""}   </th>
                        </tr>
                        <tr>
                            <td>Executed By</td>
                            <th>{expenseData?.detail?.user_data ? expenseData?.detail?.user_data?.full_name : ""}</th>
                        </tr>
                        <tr>
                            <td style={{ "width": "25%" }}>Date of Entry</td>
                            <th style={{ "width": "65%" }}>
                                {expenseData?.detail?.created_at ? DateService.dateTimeFormat(expenseData?.detail?.created_at) : "-"} </th>
                        </tr>
                    </tbody>
                </table>
                <div className="tab_content_wrapper mt-3">
                    <span className="content_heading">Payment Details</span>
                </div>
                <table className="table table-hover table-bordered  table-responsive bg-white my-2 ">
                    <thead className="table-secondary">
                        <tr>
                            <th scope="col" style={{ width: "20%" }}>Transaction Id</th>
                            <th scope="col" style={{ width: "18%" }}>Transaction Date</th>
                            <th scope="col" className="text-center" style={{ width: "17%" }}>Wallet</th>
                            <th scope="col" className="text-end" style={{ width: "18%" }}>Applied Amount</th>
                            {this.props?.showActionData && <th scope="col" className="text-center" style={{ width: "10%" }}>Action</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {
                            expenseData?.detail?.payment?.length > 0 ? expenseData?.detail?.payment.map((head, i) => {
                                return (
                                    <tr key={i}>
                                        <td>{head.transaction_id ? <Link onClick={() => this.viewPaymentDetail(head?.transaction_id)}>{head.transaction_id}
                                        </Link> : ""}</td>
                                        <td>{head?.transaction_date ? DateService.dateFormat(head?.transaction_date) : "-"}</td>
                                        <td className="text-center">{head?.wallet?.wallet_name}</td>
                                        <td className="text-end">{head?.payment_link?.payment_amount}</td>
                                        {this.props?.showActionData &&
                                            <td className="text-center">
                                                <button type="button" id='actionMenuButton' data-bs-toggle="dropdown" aria-expanded="false" className="btn " disabled={this.state.detailpdf_downloading || this.state.viewDataLoading}>
                                                    <TapIcon.FontAwesomeIcon icon={TapIcon.faEllipsisV} />
                                                </button>
                                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                    <li onClick={() => this.paymentEditInit(head)}>
                                                        <button className="dropdown-item" role="button">Edit</button>
                                                    </li>
                                                </ul> 
                                            </td>}
                                    </tr>
                                )
                            })
                                :
                                <tr><td colSpan={7} className="text-center">No Record Found</td></tr>
                        }
                    </tbody>
                </table>
                {expenseData &&
                    expenseData?.detail &&
                    expenseData?.detail?.remarks?.length > 0 ? <>
                    <div className="tab_content_wrapper mt-3">
                        <span className="content_heading">Remarks</span>
                    </div>
                    <div className="row my-2">
                        {expenseData?.detail?.remarks?.map((c, k) => {
                            return (
                                <Ax key={k}>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <span className="fw-bold link-primary"> {c.created_by} </span>
                                            Added a remark on <span className="fw-bold"> {c.created_at ? DateService.dateTimeFormat(c.created_at) : ""}</span>
                                        </div>
                                        <div className="col-sm-12 my-1"> <span> {c.remark}</span> </div>
                                    </div>
                                    <hr />
                                </Ax>
                            );
                        })}
                    </div>
                </>


                    : null}
            </Ax>

        );
    };

    render() {
        const { expenseData, viewDataLoading } = this.state;

        if (viewDataLoading) {
            return <Loader />;
        }

        if (!expenseData) {
            return <div className="text-center p-3">No expense data available</div>;
        }

        return (
            <Ax>
                {this.renderExpenseDetail(expenseData)}
                <PaymentDetailModal ref={this.paymentModalRef}  />
            </Ax>
        );
    }
}

const mapStateToProps = state => ({
    access_token: state.auth.access_token,
});

export default connect(mapStateToProps)(withRouter(ExpenseView));